import React, { useState } from "react";
import { Formik, Field, Form, setNestedObjectValues } from "formik";
import { IoIosPeople } from "react-icons/io";
import { BsFillTelephoneFill } from "react-icons/bs";
import { HiLocationMarker } from "react-icons/hi";
import BillingTable from "../BillingTable/BillingTable";
import * as yup from "yup";
function AddCustomers({ setStoreData, storeData, handleClick }) {
  const billingFormData = [
    {
      type: "text",
      placeholder: "Customer's Name ",
      apikey: "customer_name",
      label: "customer name",
    },
    {
      type: "email",
      placeholder: "Customer's Email ",
      apikey: "email",
      label: "customer email",
    },
    {
      sub: [
        {
          type: "text",
          placeholder: "Phone Number ",
          apikey: "phone_no",
          label: "phone number",
          icon: <BsFillTelephoneFill className="h-5 w-5 " />,
        },
        {
          type: "text",
          placeholder: "Address ",
          apikey: "address",
          label: " address",
          icon: <HiLocationMarker className="h-6 w-6" />,
        },
      ],
    },
  ];
  const Submits = (values) => {
    // values.TotalPrice = TotalPrice();
    // values.allData = storeData;
    console.log(values);
  };
  // const [Totals, setTotals] = useState("");
  //   const TotalPrice = () => {
  //     let total = 0;

  //     storeData?.map((val, i) => {
  //       total = total + Number(val.total);
  //       // setTotals(total);
  //     });
  //     return total;
  //   };
  const loginFormDataSchema = yup.object().shape({
    customer_name: yup.string().required("Customer Name is required"),
    email: yup.string().required("Email is required"),
    address: yup.string().required("Address is required"),
    phone_no: yup.string().required("Phone Number is required"),
    // allData: yup.string().required("Email is required"),
  });
  //   console.log(storeData);
  return (
    <div className=" mt-8  w-11/12  px-5 tablet:w-full mx-auto mobileL:mt-4">
      <Formik
        initialValues={{
          customer_name: "",
          email: "",
          address: "",
          phone_no: "",
          //   TotalPrice: "",
          //   allData: "",
        }}
        validationSchema={loginFormDataSchema}
        onSubmit={(values) => {
          // console.log(values);
          Submits(values);
        }}
      >
        {({ values, errors, touched, handleSumit, isSubmitting }) => (
          <Form>
            <div className={`   gap-6`}>
              {billingFormData?.map((val, i) => {
                if (val.sub) {
                  return (
                    <div className="laptop:grid grid-cols-2 gap-5" key={i}>
                      {val.sub.map((val, i) => {
                        return (
                          <div key={i} className="laptop:w-full   my-5">
                            <div className="capitalize  my-2">
                              <label
                                className="cursor-pointer font-semibold text-gray-600"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>
                            <div className="relative">
                              <label htmlFor={val.apikey}>
                                {" "}
                                <div className="absolute top-3  cursor-pointer left-2 text-gray-300 bg-opacity-80">
                                  {val.icon}
                                </div>
                              </label>
                              <Field
                                id={val.apikey}
                                placeholder={val.placeholder}
                                name={val.apikey}
                                className="border border-gray-300 px-10 py-2.5 w-11/12 laptop:w-full rounded-md"
                              />
                            </div>
                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                } else {
                  return (
                    <div key={i} className="full ">
                      <div className="capitalize  my-3">
                        <label
                          className="cursor-pointer text-gray-600 font-semibold"
                          htmlFor={val.apikey}
                        >
                          {val.label}
                        </label>
                      </div>
                      <div className="relative">
                        <label htmlFor={val.apikey}>
                          {" "}
                          <div className="absolute top-2.5 cursor-pointer left-1 text-gray-300 bg-opacity-80">
                            <IoIosPeople className="h-7 w-7" />
                          </div>
                        </label>
                        <Field
                          id={val.apikey}
                          placeholder={val.placeholder}
                          name={val.apikey}
                          className="border border-gray-300 px-10 py-2.5  w-11/12 laptop:w-full rounded-md"
                        />
                      </div>
                      <div
                        className={`${
                          errors[val.apikey] && touched[val.apikey]
                            ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                            : ""
                        }`}
                      >
                        {errors[val.apikey] && touched[val.apikey]
                          ? errors[val.apikey]
                          : ""}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
            <div className="flex justify-start  w-11/12">
              <button
                type="submit"
                className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
              >
                submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddCustomers;
